export function timeAgo(input) {
  if (!input) return "";
  const date = typeof input === "string" || typeof input === "number"
    ? new Date(input)
    : input;
  if (Number.isNaN(date.getTime())) return "";
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 5) return "just now";
  const units = [
    {label: "year", s: 31536000},
    {label: "month", s: 2592000},
    {label: "week", s: 604800},
    {label: "day", s: 86400},
    {label: "hour", s: 3600},
    {label: "minute", s: 60},
    {label: "second", s: 1}
  ];
  for (const u of units) {
    const n = Math.floor(seconds / u.s);
    if (n >= 1) return `${n} ${u.label}${n > 1 ? "s" : ""} ago`;
  }
  return "just now";
}
